import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import NumberFormat, { FORMAT_CURRENCY, FORMAT_PERCENT } from 'cityads-v3/components/Format/NumberFormat';
import NumberRangeFormat from 'cityads-v3/components/Format/NumberRangeFormat';
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

export default function PaidFormat({ commissionData, precision }) {
  const { t } = useTranslation(['Offers']);

  const { currency_id, amount, webmaster_currency_id, webmaster_currency_amount, percent } = commissionData || {};

  const webmasterCurrencyAmountMax = Number(webmaster_currency_amount?.max);
  const webmasterCurrencyAmountMin = Number(webmaster_currency_amount?.min);
  const offerCurrencyAmountMax = Number(amount?.max);
  const offerCurrencyAmountMin = Number(amount?.min);
  const percentMax = Number(percent?.max);
  const percentMin = Number(percent?.min);

  const hasWebmasterCurrencyAmount = webmaster_currency_id && webmaster_currency_amount && webmasterCurrencyAmountMax;
  const hasOfferCurrencyAmount = amount && offerCurrencyAmountMax;
  const hasPercent = percent && percentMax;

  const hasAmount = hasWebmasterCurrencyAmount || hasOfferCurrencyAmount;
  const amountMax = hasWebmasterCurrencyAmount ? webmasterCurrencyAmountMax : offerCurrencyAmountMax;
  const amountMin = hasWebmasterCurrencyAmount ? webmasterCurrencyAmountMin : offerCurrencyAmountMin;

  const originalCurrencyId = Number(currency_id);
  const webmasterCurrencyId = Number(webmaster_currency_id);
  const amountCurrencyId = hasWebmasterCurrencyAmount ? webmasterCurrencyId : originalCurrencyId;

  if (!hasAmount && !hasPercent) {
    return (<>—</>);
  }

  const hasConversion = hasOfferCurrencyAmount && hasWebmasterCurrencyAmount &&
    (webmasterCurrencyAmountMin !== offerCurrencyAmountMin || webmasterCurrencyAmountMax !== offerCurrencyAmountMax);

  const offerCurrencyAmountElement = hasConversion ?
    (
      (offerCurrencyAmountMin && offerCurrencyAmountMin < offerCurrencyAmountMax) ?
        (
          <NumberRangeFormat min={offerCurrencyAmountMin} max={offerCurrencyAmountMax} format={FORMAT_CURRENCY} currency={originalCurrencyId} precision={precision} />
        )
        :
        (
          <NumberFormat number={offerCurrencyAmountMax} format={FORMAT_CURRENCY} currency={originalCurrencyId} precision={precision} />
        )
    )
    :
    null;

  const amountElement = hasAmount ?
    (
      (amountMin && amountMin < amountMax) ?
        (
          <NumberRangeFormat min={amountMin} max={amountMax} format={FORMAT_CURRENCY} currency={amountCurrencyId} precision={precision} />
        )
        :
        (
          <NumberFormat number={amountMax} format={FORMAT_CURRENCY} currency={amountCurrencyId} precision={precision} />
        )
    )
    :
    null;

  return (
    <>
      {hasAmount ?
        (
          <div>
            {offerCurrencyAmountElement ?
              (
                <Tooltip isLight title={<>{t('conversionNotice')} {offerCurrencyAmountElement}</>}>
                  <span>{amountElement} *</span>
                </Tooltip>
              ) :
              amountElement
            }
          </div>
        )
        :
        null
      }
      {hasPercent ?
        (
          <div>
            {(percentMin && percentMin < percentMax) ?
              (
                <NumberRangeFormat min={percentMin} max={percentMax} format={FORMAT_PERCENT} precision={precision} />
              )
              :
              (
                <NumberFormat number={percentMax} format={FORMAT_PERCENT} precision={precision} />
              )
            }
          </div>
        )
        :
        null
      }
    </>
  );
}

PaidFormat.propTypes = {
  commissionData: PropTypes.shape({
    currency_id: PropTypes.number,
    amount: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    webmaster_currency_amount: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    percent: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
  }),
  precision: PropTypes.number,
};
